import withRouter from "components/Common/withRouter";
import PropTypes from "prop-types";
import React from "react";
import { connect, useSelector } from "react-redux";
//i18n
import { withTranslation } from "react-i18next";
import SidebarContent from "./SidebarContent";
import { Link } from "react-router-dom";
import logo from "../../assets/images/ci_logo.png";
import logoDark from "../../assets/images/logo-dark.png";
import logoSymbol from "../../assets/images/logo-symbol.svg";
import watermark from "../../assets/images/watermark.svg";
import { getRoleName } from "../../common/utility";

const Sidebar = (props) => {
  const { data } = useSelector((state) => ({
    data: state.Login.data,
  }));

  let roleName = "";

  if (data) {
    roleName = getRoleName(data.roleId);
  }

  return (
    <React.Fragment>
      <div className="vertical-menu">
        <div className="navbar-brand-box">
          <Link to={`/${roleName}/dashboard`} className="logo logo-dark">
            <span className="logo-sm">
              <img src={logo} alt="" height="22" />
            </span>
            <span className="logo-lg">
              <img src={logoDark} alt="" height="17" />
            </span>
          </Link>

          <Link className="logo logo-light">
            <span className="logo-sm">
              <img
                src={logoSymbol}
                alt=""
                height="40"
                style={{
                  borderBottom: "1px solid white",
                  paddingBottom: "5px",
                }}
              />
            </span>
            <span className="logo-lg">
              <img
                src="https://payearly.cashinvoice.in/assets/images/CashInvoiceLogo.png"
                alt=""
                height="40"
              />
            </span>
          </Link>
        </div>
        <div className="ci-watermark">
          <div data-simplebar className="h-100 ci-sidebar">
            <SidebarContent />
          </div>
          <img src={watermark} className="ci-img-logo" />
        </div>
        {/* <div className="sidebar-background"> <SidebarContent /></div> */}
      </div>
    </React.Fragment>
  );
};

Sidebar.propTypes = {
  type: PropTypes.string,
};

const mapStatetoProps = (state) => {
  return {
    layout: state.Layout,
  };
};
export default connect(
  mapStatetoProps,
  {}
)(withRouter(withTranslation()(Sidebar)));
